<template>
  <div id="pathways-calendar" class="bg-white rounded-lg px-10 py-5 my-10 md:mt-0 shadow">
    <div class="flex  items-center py-3">
      <div class="w-1/2 flex items-center">
        <d-icon class="text-secondary-500" size="lg" icon="calendar-alt" />
        <p class="font-bold px-3">
          This Week
        </p>
      </div>
      <div class="w-1/2 text-right">
        <a href="/calendar">
          View Full Calendar
        </a>
      </div>
    </div>
    <ejs-schedule ref="scheduleObj" :read-only="true" height="300px" :current-view="currentView" :time-scale="timeScale" :event-settings="eventSettings" :popup-open="onPopupOpen" :quick-info-templates="quickInfoTemplates" :event-rendered="onEventRendered">
      <e-views>
        <e-view option="Week" />
      </e-views>
    </ejs-schedule>
  </div>
</template>

<script>
  import {
    Day, Week, Month,
  } from '@syncfusion/ej2-vue-schedule';
  import { removeClass } from '@syncfusion/ej2-base';
  import dataManager from '@resources/scripts/plugins/syncfusion/mainCalendar';
  import Vue from 'vue';
  import QuickInfoFooter from './QuickInfoFooter.html';
  import EventTemplate from './EventTemplate.vue';
  import QuickInfoContent from './QuickInfoContent.vue';

  export default {
    provide: {
      schedule: [Day, Week, Month],
    },

    data() {
      const vm = this;
      return {
        timeScale: {
          enable: false,
        },
        currentView: 'Week',
        eventSettings: {
          dataSource: dataManager,
          template(e) {
            return {
              template: EventTemplate,
            };
          },
          fields: {
            id: 'id',
            subject: { name: 'name' },
            description: { name: 'description' },
            startTime: { name: 'dateTime' },
            endTime: { name: 'dateTime' },
          },
        },
        quickInfoTemplates: {
          content(e) {
            return {
              template: QuickInfoContent,
            };
          },
          footer(e) {
            return {
              template: Vue.component('footerTemplate', {
                data() {
                  return {
                    data: {},
                    mainVm: vm,
                  };
                },
                template: QuickInfoFooter,
              }),
            };
          },
        },
      };
    },

    methods: {
      onPopupOpen(args) {
        if (args.type === 'Editor' || (args.type === 'QuickInfo' && !args.data.id)) {
          args.cancel = true;
        }
      },

      onEventRendered(args) {
        if (!args.element || !args.data.owner) {
          return;
        }

        if (this.currentView === 'Agenda') {
          args.element.firstChild.style.borderLeftColor = args.data.owner.colorCode;
        } else {
          args.element.style.backgroundColor = args.data.owner.colorCode;
        }
      },
    },
  };
</script>